import { UseQueryResult, useQueryClient } from '@tanstack/react-query';
import { useCustomQuery } from '../graphql';

export const CONFIG_CACHE_KEY = ['config'];

export const useInvalidateConfig = () => {
  const queryClient = useQueryClient();
  return async () =>
    await queryClient.invalidateQueries({ queryKey: CONFIG_CACHE_KEY });
};

export type useConfigHook = () => UseQueryResult<any, any>;

export const useConfig = () => {
  return useCustomQuery({
    cacheKey: CONFIG_CACHE_KEY,
    query: CONFIG_QUERY,
    options: {
      queryKey: CONFIG_CACHE_KEY,
      staleTime: Infinity,
    },
  });
};

// DEPLOY ORDERING — removing a field here is a two-phase change.
// The pipeline deploys API before web (deploy_web `needs: deploy_api`), and this
// is a single-bundle SPA with no code splitting: an already-loaded session keeps
// running the old JS (and firing this query) until a full page reload. So if you
// drop a field from BOTH this query and the `Configuration` schema in one release,
// the new API rejects the old bundle's query with a GraphQL validation error
// ("Cannot query field X on type Configuration") for the whole deploy window plus
// the tail of stale open tabs.
//   1. Remove the field from THIS query first; ship and let it deploy.
//   2. Remove the field from the backend schema/resolver in a LATER release,
//      once no live bundle still asks for it.
// (Adding a field is safe in one PR — old bundles simply don't request it.)
export const CONFIG_QUERY = `
  query config {
    config {
      mediaUploadUrl
    }
  }
`;
